import { post, fetch, Del, put } from "@/ask/axios";
import { getCookie } from '@/ask/cookiejs'
import menberMenu from '@/components/userCenter/public/menberPageMenu.vue'
import { downloadFile, fileSteamDownload } from '@/utils/download'
import shareOrder from "@/components/userCenter/public/shareOrder";

export default {
  components: { menberMenu, shareOrder },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      titNames: 'Air Freight Shipment ,Details',
      titUrls: '/air/airList,',

      myHeaders: {
        ['X-JWT-TOKEN']: getCookie('X-BY-EnTOKEN')
      },
      upLoadData: {
        PathName: 'air/order',
        IsTempFile: false
      },//导入文件

      //tab选项卡
      activeName: 'first',

      //订单详情
      waybillNO: '',
      //提单总和信息
      StorageBillTotal: '',
      CostTotal: '', //入仓总计

      //入仓求和信息
      CostVolumeTotal: '',
      CostWeightTotal: '',
      CostQuanlityTotal: '',
      CostVolumeWeightTotal: '',

      //提单求和
      StorageQuanlitySum: '',
      StorageVolumeSum: '',

      //空运和单独费用显示
      airFee: [],
      aloneFee: [],

      //费用求和
      UnpaySum: '',
      UnpaySumCn: '',

      isCol: false,
      Remarks: '',//分享订单备注
      RemarksMesg: '',//分享订单备注
      EmailId: '',//分享邮箱
      EmailMesg: '邮箱分享',

      fileList1: [],
      fileList2: [],
      fileList3: [],

      // 各种接口数据
      OrderAllDetail: '', //订单总信息
      OrderDetail: '', //订单信息
      OrderCost: '',//费用信息
      StorageBillInfo: '', //入仓 --提单信息
      CostInfo: '', //入仓 - 入仓信息
      OrderContact: '', //收发联系人
      airLineInfo: '', //航班信息
      OrderEnclosure: '', //订单附件
      OrderTDEnclosure: '', //订单提单附件
      OrderInfoTrack: '', //轨迹
      CargoDoc: '', //随机文件
      DeliverContact: '', ///派送联系人信息
      // 遮罩层
      showModal: false,
      addSendBox: false,


      PackageUnit: '',
      AmountName: '',//整个账单的币种符合

      //查看详情
      seeDetailFlag1: false,
      seeDetailFlag: false,
      //轨迹图
      StartAddrInfo: '', //起运地
      WarehouseInfo: '', //仓库信息
      StartAirInfo: '', //起飞机场
      TransAirInfos: '',//货物中转
      DestAirInfo: '',//目的机场
      inFore: false, //报关时间是否在到达时间前
      DestAddrInfo: '',//目的地

      //展示轨迹图的Flag 控制器
      StartAddrFlag: false, //起运地
      WarehouseFlag: false, //仓库信息
      StartAirFlag: false, //起飞机场
      TransAirFlag: false,//货物中转
      DestAirFlag: false,//目的机场
      DestAddrFlag: false,//目的地

      DestinationFlag: false, //目的地显示 只要目的地为机场才显示

      airShareBox: false, //弹框分享
      // 参考号
      IsCustomerID: '',
      CustomerIDUp: '',
      CustomerIDUpTip: false,
      // POA
      poaData: '',

      airBasicFee: '', //合并后的空运费

      Bill: {}, //账单显示格式
      PowerofAttorney: [],
      CommercialInvoice: [],
      PackingList: [],
      // 总计含有的币种显示

    }

  },
  computed: {
    // 服务类型
    getOrderServiceType() {
      //5：FOB，6：EXW，7：FCA
      switch (this.OrderDetail.OrderServiceType) {
        case 1:
          return 'Door to Door'
        case 2:
          return 'Door to Terminal'
        case 3:
          return 'Terminal to Terminal'
        case 4:
          return 'Terminal to Door'
        case 5:
          return 'FOB'
        case 6:
          return 'EXW'
        case 7:
          return 'FCA'
      }
    },
    //详情统计小计总和（下方）
    getAloneFeeTotal() {
      let Sum = "0"
      this.aloneFee.forEach(element => {
        if (element.Currency == 2) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.ConvertAmount)
        }
      });
      return Sum
    },
    getAloneFeeTotalCn() {
      let Sum = "0"
      this.aloneFee.forEach(element => {
        if (element.Currency == 1) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.Amount)
        }
      });
      return Sum
    },
    getAloneFeeTotalHK() {
      let Sum = "0"
      this.aloneFee.forEach(element => {
        if (element.Currency == 3) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.ConvertAmount)
        }
      });
      return Sum
    },
    getAloneFeeTotalEUR() {
      let Sum = "0"
      this.aloneFee.forEach(element => {
        if (element.Currency == 4) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.ConvertAmount)
        }
      });
      return Sum
    },
    //详情统计小计总和（上方）
    getAirFeeTotal() {
      let Sum = "0"
      this.airFee.forEach(element => {
        if (element.Currency == 2) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.ConvertAmount)
        }
      });
      return Sum
    },
    getAirFeeTotalRMB() {
      let Sum = '0'
      this.airFee.forEach(element => {
        if (element.Currency == 1) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.Amount)
        }
      });
      return Sum
    },
    getAirFeeTotalHK() {
      let Sum = "0"
      this.airFee.forEach(element => {
        if (element.Currency == 3) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.ConvertAmount)
        }
      });
      return Sum
    },
    getAirFeeTotalEUR() {
      let Sum = '0'
      this.airFee.forEach(element => {
        if (element.Currency == 4) {
          if (typeof (Sum) !== 'number') {
            Sum = Number(Sum)
          }
          Sum += Number(element.ConvertAmount)
        }
      });
      return Sum
    }

  },
  created() {
    this.waybillNO = this.$route.query.ord
    this.firstEnter()
    this.GetOrderDetail()  //获取订单详情

  },
  mounted() {
    let from = this.$route.query.from
    // 订单成功页跳转过来
    if (from == 1) {
      this.activeName = 'fifth'
    }
  },
  methods: {
    aggregate() {
      this.getCostInfo() //获取费用信息
      this.getAirOrderContactInfo() //用户联系人信息
      this.getStorageBillInfo() //获取提单信息
      this.getStorageInfo() //入仓信息
      this.getFlightInfo() // 航班信息
      this.ExpOderEnclosure() //附件信息
      this.AirOrderInfoTrack() //轨迹信息
      this.GetCargoDoc() //随机文件
      this.GetDeliverOrder()
      this.getPOA()
    },
    blurID() {
      if (String(this.CustomerIDUp).trim() == '' || !this.CustomerIDUp) {
        this.CustomerIDUpTip = true
      } else {
        this.CustomerIDUpTip = false
      }
    },

    getPOA() {
      this.api.param = {
        "id": this.OrderDetail.DestSvcID,
      }
      this.api.url = this.$api01 + "/api/InfoCustomer/AirChannel/GetPoaInfo";
      fetch(this.api.url, this.api.param).then((res) => {
        //console.log(res,'poa')
        if (res.IsOK == true) {
          this.poaData = res.Results
          if (!this.poaData) {
            this.poaData = {
              IsPOA: ''
            }
          }
        }
      })
    },

    firstEnter() {
      //展示轨迹图的Flag 控制器
      this.StartAddrFlag = true //起运地
      this.WarehouseFlag = true //仓库信息
      this.StartAirFlag = true //起飞机场
      this.TransAirFlag = true//货物中转
      this.DestAirFlag = true//目的机场
      this.DestAddrFlag = true//目的地
    },
    CustomerIDUpdate(id) {
      this.CustomerIDUpTip = false
      if (this.IsCustomerID) {
        this.IsCustomerID = false;
      } else {
        this.IsCustomerID = true;
        this.CustomerIDUp = id;
      }
    },
    // 操作 -------------
    //导出订单
    ExportBill() {
      let that = this;
      this.api.param = {
        waybillNO: that.waybillNO
      }
      this.api.url = this.$api03 + "/api/ReportFeeBill/BillCostReportQueryEn"
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK == true) {
          // 创建隐藏的可下载链接
          let Name = 'Billing_' + that.$route.query.ord + '_' + new Date().Format('yyyyMMdd') + '.pdf'
          let url = res.Results
          // console.log(url, "url");
          // downloadFile(url, Name)
          fileSteamDownload(that, {
            FullPath: url, // 路径
            CurrentFileName: Name // 文件名称
          }, Name)
        } else {
          that.$alert('Export failure', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confrim',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            center: true
          }).then(() => {
          }).catch(() => {
          });
        }
      }
      );
    },
    expName(url, filename) {
      this.getBlob(url).then(blob => {
        this.saveAs(blob, filename);
      });
    },
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();

        window.URL.revokeObjectURL(link.href);
      }
    },
    //下载附件信息
    DownloadAttachments(id, name) {
      let url = id
      // console.log(url, "导出空运附件");
      // window.location.href = url
      fileSteamDownload(this, {
        FullPath: url, // 路径
        CurrentFileName: name // 文件名称
      }, name)
    },
    batAttSuccess1(file, fileList) {
      if (file.Results.UploadPath) {
        this.fileList1 = [{
          Url: file.Results.UploadPath,
          OriginName: fileList.name,
          BuildName: this.waybillNO + '_' + fileList.name,
          AttachType: 7,   //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
          UploadType: 0,   //上传人.0：客户上传，1：后台上传，2：供应商上传
        }]
      }
    },
    batAttSuccess2(file, fileList) {
      if (file.Results.UploadPath) {
        this.fileList2 = [{
          Url: file.Results.UploadPath,
          OriginName: fileList.name,
          BuildName: this.waybillNO + '_' + fileList.name,
          AttachType: 8,   //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
          UploadType: 0,   //上传人.0：客户上传，1：后台上传，2：供应商上传
        }]
      }
    },
    batAttSuccess3(file, fileList) {
      if (file.Results.UploadPath) {
        this.fileList3 = [{
          Url: file.Results.UploadPath,
          OriginName: fileList.name,
          BuildName: this.waybillNO + '_' + fileList.name,
          AttachType: 9,   //1：提单附件，2：报关底单，3：保险凭证，4：其他，5：订单资料，6，客户上传附件，通过接口上传的，没有固定哪个类型，都当订单资料类型处理
          UploadType: 0,   //上传人.0：客户上传，1：后台上传，2：供应商上传
        }]
      }
    },
    //删除
    clkDelFile(index, val) {
      let num = 'fileList' + val
      this[num].splice(index, 1)
    },
    SavePOA() {
      let AttachList = this.fileList1.concat(this.fileList2, this.fileList3)
      this.api.param = {
        "WaybillNO": this.waybillNO,
        "AttachList": AttachList
      }
      this.api.url = this.$api03 + "/api/TradeCustomer/AirOrderEn/UploadDocuments";
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK == true) {
          this.$alert('Saved successfully', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            center: true
          }).then(() => {
            this.ExpOderEnclosure()
          }).catch(() => {
          });
        } else {
          this.$alert('Save failed', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            center: true
          }).then(() => {
          }).catch(() => {
          });
        }
      })
    },

    //参考号
    UpdataRefNO() {
      if (String(this.CustomerIDUp).trim() == '' || !this.CustomerIDUp) {
        this.CustomerIDUpTip = true
        return false
      }
      this.$confirm("Do you save the reference number?", "", {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        center: true
      })
        .then(() => {
          this.SaveRefNOApi();
        })
        .catch(() => {
        });
      return false;
    },
    //参考号Api ----暂时有问题

    SaveRefNOApi() {
      let that = this;
      that.api.param = {
        "WaybillNO": that.waybillNO,
        "RefNO": that.CustomerIDUp
      }
      that.api.url = that.$api03 + "/api/TradeCustomer/AirOrder/UpdateAirRefNO";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.IsCustomerID = false
          that.GetOrderDetail()
        }
      })
    },
    //取消保存参考号
    cancel() {
      this.IsCustomerID = false;
    },
    //显示隐藏轨迹图
    showTrajectory(flag) {
      switch (flag) {
        case 1:
          this.StartAddrFlag = !this.StartAddrFlag
          break;
        case 2:
          this.WarehouseFlag = !this.WarehouseFlag
          break;
        case 3:
          this.StartAirFlag = !this.StartAirFlag
          break;
        case 4:
          this.TransAirFlag = !this.TransAirFlag
          break;
        case 5:
          this.DestAirFlag = !this.DestAirFlag
          break;
        case 6:
          this.DestAddrFlag = !this.DestAddrFlag
          break;
        default:
          break;
      }
    },
    ///---------------计算----------
    //求和计算入仓Storage金额
    getCostSum(Type) {
      let Sum = 0
      this.CostInfo.AirOrderInstoreGVList.forEach(element => {
        Sum += element[Type]
      });
      let CostType = `Cost${Type}Total`
      this[CostType] = Sum
    },
    /**
 * @param {String} Type  传入计算的类型名称
 * 计算体积和
 */
    StorageTotal(Type) {
      //通过long wide high 求 体积
      if (Type == 'getVolume') {
        this.StorageBillInfo.AirOrderInfoBillGVList.forEach(element => {
          element.Volume = Number((element.Long * element.High * element.Wide) * element.Quanlity) / 1000000
        });
        return
      }
      let Sum = 0
      this.StorageBillInfo.AirOrderInfoBillGVList.forEach(element => {
        Sum += Number(element[Type])
      });
      let SumType = `Storage${Type}Sum` //eg: StorageQuanlitySum ,在data定义一个StorageQuanlitySum
      this[SumType] = Sum
    },
    /**
     *
     */
    //计算未支付的总和
    UnpaySumFn(Data) {
      Data = Data.filter((element) => {
        return element.BillStatus != 1
      })
      let Sum = 0
      let SumCn = 0
      let SumHK = 0
      let SumEUR = 0
      Data.forEach(element => {
        if (element.Currency == 1) {
          SumCn += Number(element.Amount)
        }
        if (element.Currency == 2) {
          Sum += Number(element.ConvertAmount)
        }
        if (element.Currency == 3) {
          SumHK += Number(element.ConvertAmount)
        }
        if (element.Currency == 4) {
          SumEUR += Number(element.ConvertAmount)
        }
      });
      this.UnpaySum = Sum
      this.UnpaySumCn = SumCn
      this.UnpaySumHK = SumHK
      this.UnpaySumEUR = SumEUR
      // forEach(element => {

      // });

    },

    // +++++++++++接口队列++++渲染数据++++++
    // -------------- 获取信息-------
    //随机文件
    GetCargoDoc() {
      let that = this;
      that.api.url = that.$api04 + "/Air/api/CargoDoc/Query";
      that.api.param = {
        WaybillNO: that.waybillNO,
      }
      post(that.api.url, that.api.param).then((res) => {
        if (res.IsOK) {
          that.CargoDoc = res.Results
        } else {
        }
      })
    },
    handleBatExceed(files, fileList) { //限制最大个数的
      this.$message.warning('Upload up to 5 attachments!')
    },
    beforeBatUpload(file, fileList) {  //上传文件之前做验证
      const extension = ' .jpg, .jpeg, .gif, .png, .bmp, .pic, .doc, .docx, .rar, .xls, .xlsx, .pdf, .zip, .7z, '
      var fileName = file.name;
      var ext = fileName.substring(fileName.lastIndexOf('.'), fileName.length) + ", ";

      if (extension.indexOf(ext) == -1) {
        this.$confirm('The imported file can only be in' + extension + 'format!', '', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {

        }).catch(() => {

        });
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      const isLtZeroM = file.size / 1024 / 1024 > 0
      if (!isLt2M) {
        this.$confirm('Upload file size is over 10M!', '', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {

        }).catch(() => {

        });
        return false
      }
      if (!isLtZeroM) {
        this.$confirm('The file size is 0kb, please re-upload!', '', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {

        }).catch(() => {

        });
        return false
      }
      //上传文件名不能超多100个字符
      if (fileName.length > 100) {
        this.$confirm('The file name is over 100 characters,please re-upload！', '', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {

        }).catch(() => {

        });
        return false
      }
      return true
    },
    //派送信息
    GetDeliverOrder() {
      let that = this;
      that.api.url = that.$api04 + "/Air/api/DeliverOrder/Query";
      that.api.param = {
        WaybillNO: that.waybillNO,
      }
      post(that.api.url, that.api.param).then((res) => {
        if (res.IsOK) {
          that.DeliverContact = res.Results.DeliverContact
        } else {
        }
      })
    },

    //获取订单详情
    GetOrderDetail() {
      let that = this;
      // 判断是否是以条款（FCA/FOB等）下单，即用户是海外同行
      let userType = JSON.parse(sessionStorage.getItem("customerInfos"))
        .CustomerOwnerType;
      that.api.url = userType == 2 ? that.$api04 + '/Air/api/AirOrder/Detail' : that.$api04 + "/Air/api/AirOrder/Detail";
      that.api.param = {
        waybillNO: that.waybillNO,
      }
      post(that.api.url, that.api.param).then((res) => {
        if (res.IsOK) {
          that.OrderAllDetail = res.Results
          that.OrderDetail = { ...res.Results.Order, ...res.Results.OrderExt, ...res.Results.OrderInsurance, ...res.Results.InfoBill }
          that.showDestination()
          this.aggregate()  //信息集合
        } else {
        }
      })
    },
    AmountNameGet(id) {
      if (id == 1) return '￥';
      if (id == 2) return 'US $';
      if (id == 3) return 'HK $';
      if (id == 4) return '€';
    },
    //显示轨迹的目的地
    showDestination() {
      if (this.OrderDetail.OrderServiceType == 2 || this.OrderDetail.OrderServiceType == 3) {
        this.DestinationFlag = false // 不显示
      } else {
        this.DestinationFlag = true
      }
    },
    //获取费用信息
    getCostInfo() {
      this.OrderCost = this.OrderAllDetail.BillList
      this.SortFee()
      this.Bill = {
        topShow: this.airFee,
        botShow: this.aloneFee,
        isHaveRMB: false, isHaveUSD: false, isHaveHK: false, isHaveEUR: false,
        topUnpayCny: 0, topUnpayUSD: 0, topUnpayHK: 0, topUnpayEUR: 0,
        botUnpayCny: 0, botUnpayUSD: 0, botUnpayHK: 0, botUnpayEUR: 0,
        topSumCNY: 0, topSumUSD: 0, topSumHK: 0, topSumEUR: 0,
        botSumCNY: 0, botSumUSD: 0, botSumHK: 0, botSumEUR: 0,
      }
      this.handleBill(this.Bill.topShow, "top")
      this.handleBill(this.Bill.botShow, "bottom")
    },
    /**
     * 处理费用显示
     * @param {Array} data 处理的数组
     * @param {String} flag 判断位置
    */
    handleBill(data, flag) {
      // 都要对应位置  1 为 RMB 2 USD 3 HK 4EUR
      let index = ['isHaveRMB', 'isHaveUSD', 'isHaveHK', 'isHaveEUR'] //币种索引
      let UnpayIndex = ['topUnpayCny', 'topUnpayUSD', 'topUnpayHK', 'topUnpayEUR'] //上方未支付币种统计索引
      let sumIndex = ['topSumCNY', 'topSumUSD', 'topSumHK', 'topSumEUR'] //总计币种统计索引
      if (flag === 'bottom') {
        sumIndex = ['botSumCNY', 'botSumUSD', 'botSumHK', 'botSumEUR'] //总计币种统计索引
        UnpayIndex = ['botUnpayCny', 'botUnpayUSD', 'botUnpayHK', 'botUnpayEUR'] //未支付币种统计索引
      }
      data.forEach(e => {
        // 用于显示的总金额
        if (e.Currency == 1) {
          e.allAmout = e.Amount
        } else {
          e.allAmout = e.ConvertAmount
        }
        //  BillStatus 1 ==>已完成
        if (e.BillStatus == 1) {
          e.UnpayAmount = e.CreditAmount - e.PayCreditAmount
        } else {
          e.UnpayAmount = e.allAmout - e.AccountAmount - e.PayCreditAmount
        }
        //统计加和未支付 状态已完成的也有未支付
        this.Bill[UnpayIndex[e.Currency - 1]] += Number(e.UnpayAmount)
        this.Bill[sumIndex[e.Currency - 1]] += Number(e.allAmout)
        this.Bill[index[e.Currency - 1]] = true //是否显示该币种
      });
    },
    SortFee() {
      this.airFee = []
      this.aloneFee = []
      let top = []
      let bot = []
      for (let i = 0; i < this.OrderCost.length; i++) {
        const ele = this.OrderCost[i];
        if (ele.Direction) {
          ele.Amount = -ele.Amount;
          ele.ConvertAmount = -ele.ConvertAmount;
        }
        if (ele.BillCreateType == 0 && ele.BalanceFlag != 1) {
          top.push(ele) //系统生成
        } else {
          bot.push(ele) //放在下方
        }
      }
      this.airFee = top
      this.aloneFee = bot
    },
    //联系人信息
    getAirOrderContactInfo() {
      let that = this;
      this.api.param = {
        waybillNO: that.waybillNO
      }
      this.api.url = this.$api04 + "/Air/api/AirOrderContactInfo/Get";
      fetch(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK) {
          that.OrderContact = res.Results
        }
      })
    },
    //入仓信息
    getStorageInfo() {
      let that = this;
      this.api.param = {
        'waybillNO': that.waybillNO
      }
      // this.api.url = this.$api03 + "/api/AirOrderInstore/Get";
      this.api.url = this.$api04 + "/Air/api/AirOrderInstore/Get";
      fetch(this.api.url, this.api.param).then(function (res) {
        //console.log('第一步..........'+JSON.stringify(res))
        if (res.Results) {
          that.CostInfo = res.Results
          that.CostTotal = that.CostInfo.AirOrderInstore
          // that.getCostSum('Volume')//求和计算入仓Storage金额
          // that.getCostSum('Weight')//求和计算入仓Storage金额
          // that.getCostSum('Quanlity')//求和计算入仓Storage金额
          // that.getCostSum('VolumeWeight')//求和计算入仓Storage金额
        }
      })
    },
    //入仓信息-提单信息
    getStorageBillInfo() {
      let that = this;
      this.api.param = {
        waybillNO: that.waybillNO
      }
      // this.api.url = this.$api03 + "/api/AirOrderInfoBill/Get";
      this.api.url = this.$api04 + "/Air/api/AirOrderInfoBill/Get";
      fetch(this.api.url, this.api.param).then(function (res) {
        if (res.Results) {
          //提单信息
          that.StorageBillInfo = res.Results;//材积信息
          that.StorageBillTotal = that.StorageBillInfo.AirOrderInfoBill
          //计算体积和 件数和   计算体积
          that.StorageTotal('getVolume') //注意Volume不能放下面
          // that.StorageTotal('Quanlity')
          // that.StorageTotal('Volume')
        }
      })
    },
    //航班信息
    getFlightInfo() {
      let that = this;
      this.api.param = {
        waybillNO: that.waybillNO,
      }
      // this.api.url = this.$api03 + "/api/AirOrderBooking/Get"
      this.api.url = this.$api04 + "/Air/api/AirOrderBooking/Get"
      fetch(this.api.url, this.api.param).then(function (res) {
        that.airLineInfo = res.Results;
      }
      );
    },
    //订单提单附件信息
    ExpOrderTDEnclosure() {
      let that = this;
      that.api.param = {
        waybillNO: that.waybillNO
      }
      that.api.url = that.$api04 + "/Air/api/OrderAttach/TDQuery";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.OrderTDEnclosure = res.Results  //订单附件信息
          // 未支付总计
          // if (!that.OrderCost.length || that.UnpaySum > 0) {
          //   // 筛选出供应商的信息
          //   that.OrderTDEnclosure = that.OrderTDEnclosure.filter((element) => {
          //     return element.UploadType != 2
          //   })
          // }
          that.OrderEnclosure.push(...that.OrderTDEnclosure) //全部订单信息
          // 进行时间排序
          that.OrderEnclosure.sort(function (a, b) {
            return Date.parse(a.CreateTime) - Date.parse(b.CreateTime)
          })
          for (let i = 0; i < that.OrderEnclosure.length; i++) {
            const ele = that.OrderEnclosure[i];
            //console.log(ele.AttachType)
            if (ele.AttachType == 7) {
              that.PowerofAttorney = []
              that.PowerofAttorney.push(ele)
            } else if (ele.AttachType == 8) {
              that.CommercialInvoice = []
              that.CommercialInvoice.push(ele)
            } else if (ele.AttachType == 9) {
              that.PackingList = []
              that.PackingList.push(ele)
            }
          }
        }
      })
    },
    //
    getTgoodFee() {
      this.api.param = {
        BusinessNO: that.waybillNO
      }
      this.api.url = this.$api04 + "/Bill/api/FEBill/Query";
      return new Promise((resolve, reject) => {
        fetch(this.api.url, this.api.param).then((res) => {
          let a = res;
          resolve(a);
        });
      });
    },
    orderStatus(val) {
      // 新的：0=未确认，1=已确认，2=已接单   ，3= 已订舱 ，4= 转运中 ， 5= 已完成 ，
      //6= 已退件 ，7= 已撤销 ，8： 派送中
      if (val == '未确认') return 'Confirming'
      if (val == '已确认') return 'Confirmed'
      if (val == '已接单') return 'Received'
      if (val == '已订舱') return 'Reserved'
      if (val == '转运中') return 'Delivering'
      if (val == '已完成') return 'Completed'
      if (val == '已退件') return 'Returned'
      if (val == '已撤销') return 'Canceled'
      if (val == '派送中') return 'Distribute'
    },
    ///我的消息
    SrcFrom(id) {
      var imtoken = $.cookie('IMEn-TOKEN');
      return this.$apiIMEn + 'chats/Worklist?orderid=' + id + '&trackid=' + imtoken + '&lan=English';
    },
    ExpOderEnclosure() {
      let that = this;
      that.api.param = {
        waybillNO: that.waybillNO
      }
      that.api.url = that.$api04 + "/Air/api/OrderAttach/Query";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.OrderEnclosure = res.Results  //订单附件信息
          that.ExpOrderTDEnclosure() //订单提单附件
          //console.log('ss'+JSON.stringify(res));
        }
      })
    },
    //轨迹接口
    AirOrderInfoTrack() {
      this.api.param = {
        waybillNO: this.waybillNO,
        Origin: 50
      }
      this.api.url = this.$api04 + "/Air/api/AirOrderInfoTrack/GetTranckNodeInfo";
      post(this.api.url, this.api.param).then((res) => {
        //console.log(res)
        if (res.IsOK == true) {
          this.OrderInfoTrack = res.Results
          this.StartAddrInfo = this.OrderInfoTrack.StartAddrInfo //起运地
          this.WarehouseInfo = this.OrderInfoTrack.WarehouseInfo //仓库信息
          this.StartAirInfo = this.OrderInfoTrack.StartAirInfo //起飞机场
          this.TransAirInfos = this.OrderInfoTrack.TransAirInfos//货物中转
          this.DestAirInfo = this.OrderInfoTrack.DestAirInfo//目的机场
          this.DestAddrInfo = this.OrderInfoTrack.DestAddrInfo//目的地
          //console.log(this.StartAirInfo.ArriveTime,"到达时间" , this.WarehouseInfo.CustomsTime)
          if (this.StartAirInfo.ArriveTime && this.WarehouseInfo.CustomsTime) {
            if (new Date(this.StartAirInfo.ArriveTime).getTime() > new Date(this.WarehouseInfo.CustomsTime).getTime()) {
              this.inFore = true
            } else {
              this.inFore = false
            }
          }
        }
      })
    },
    ShareOrder() {
      this.$refs.shareOrder.clkDialog(this.waybillNO);
    },

  }
}



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/air/AirDetails.js